import createStyles from "@material-ui/core/styles/createStyles";
import amber from "@material-ui/core/colors/amber";
import green from "@material-ui/core/colors/green";
import { Theme } from "@material-ui/core";

export const styles = ({ palette, spacing }: Theme) => createStyles({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: palette.error.dark,
    },
    info: {
        backgroundColor: palette.primary.dark,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: spacing.unit,
    },
    message: {
        display: "flex",
        alignItems: "center",
    }
});


// WEBPACK FOOTER //
// ./src/components/Notification/Notification.style.tsx